import {
  Box,
  BoxProps,
  Card,
  CardContent,
  CardHeader,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import _ from 'lodash';
import { CustomIcon } from 'modules/components/layer00';
import React, { ReactNode } from 'react';
import { theme } from 'theme';



export type TaskPaneCardProps = {
  id: string;
  title: string;
  dueIn: number;
  area: string;
  category: string;
  showTaskModal: (id: string) => void;
};

type IFieldNames = Exclude<keyof TaskPaneCardProps, 'id' | 'showTaskModal'>;


const fieldName2Label: Record<IFieldNames, string> = {
  title: 'Title',
  dueIn: 'Due In',
  area: 'Area',
  category: 'Category'
};


const fieldName2Icon: Record<IFieldNames, () => ReactNode> = {
  title: () => <CustomIcon.large.FC icon='DOC' stroke={theme.palette.primary.main} />,
  dueIn: () => <CustomIcon.large.FC icon='DOC' stroke={theme.palette.primary.main} />,
  area: () => <CustomIcon.large.FC icon='DOC' stroke={theme.palette.primary.main} />,
  category: () => <CustomIcon.large.FC icon='DOC' stroke={theme.palette.primary.main} />
};


/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: TaskPaneCardProps & BoxProps) => {
  const theme = useTheme();

  return (
    <Card
      onClick={() => props.showTaskModal(props.id)}
      sx={{
        borderRadius: '20px',
        flex: '1 -1 0',
        minWidth: '300px',
        minHeight: '10rem'
      }}
      id={props.id}
    >
      <CardHeader
        sx={{
          bgcolor: '#10B99F',
          color: '#FFFFFF'
        }}
        title={props.title}
      />
      <CardContent>
        <Stack
          direction='row'
        >
          <Box>
            <Typography
              variant='modalTitle'
            >
              {props.title}
            </Typography>
          </Box>
        </Stack>



        {TaskCardFieldRow('dueIn', props.dueIn.toString())}
        {TaskCardFieldRow('area', props.area)}
        {TaskCardFieldRow('category', props.category)}

      </CardContent>

    </Card>
  );
};
function TaskCardFieldRow(fieldName: IFieldNames, value: string) {
  return (
    <Stack
      direction='row'
      alignItems='center'
      columnGap='1rem'
    >
      {fieldName2Icon[fieldName]()}
      <Typography
        variant='displayFieldLabel'
      >
        {fieldName2Label[fieldName]}
      </Typography>
      <Typography
        variant='displayFieldValue'
      >
        {value}
      </Typography>
    </Stack>
  );
}

